import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MerakiOrganizationFieldComponent } from './meraki-organization-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    MerakiOrganizationFieldComponent,
  ],
  exports: [
    MerakiOrganizationFieldComponent,
  ],
})
export class MerakiOrganizationExportModule {}
